<template>
  <div class="d-show-event" :data-event-id="event ? event.event_id : ''"
       :class="{'d-show-event__changes-made': isChangesMade}" v-on-clickaway="closeClick"
       ref="d_show_event">
    <div class="d-show-event__init-loader" v-if="!isEveryThingReady">
      <div class="d-show-event__close d-show-event__close__loader icon__bg-circle" @click="closeClick"
           :content="escTooltip"
           v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212
               }">
        <span class="icon-cross2"></span>
      </div>
      <Loader bg-color="#f6f9fc"></Loader>
    </div>
    <div class="d-show-event__content" v-else>
      <div class="d-show-event__header"
           ref="d_show_event_header"
           :style="{backgroundColor: event.color }">
        <div class="d-show-event__header__do-warning__container">
          <div class="d-show-event__header__do-warning do-warning do-warning--canceled" v-if="isCanceled">
            <span class="icon-notification22"></span>
            {{ i18n[locale].canceled }}
          </div>
          <div class="d-show-event__header__do-warning do-warning" v-if="isAway">
            <span class="icon-home2 icon-home2-away" style="margin-right: 2px"></span>
            {{ i18n[locale].out_of_school }}</div>
        </div>
        <div class="d-show-event__header__top" ref="copy_event_button" id="vue-popper__copy_event_button">
          <template v-if="isCanEditEvent">
            <div class="icon__bg-circle"
                 v-if="event.calendar_id !== calendarId"
                 @click="goToCalendarForLesson"
                 :content="i18n[locale]['go_to_calendar']"
                 v-tippy="{
          placement: 'bottom',
          zIndex: 1212121212
        }">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="tw-icon w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"/>
              </svg>
            </div>
            <div class="icon__bg-circle dialog-header__bin"
                 v-if="event.calendar_id !== calendarId && eventMainCalendarType === 'merge'"
                 @click="setIsConfirmDeleteMerge"
                 :content="i18n[locale]['only_delete_this']"
                 v-tippy="{
          placement: 'bottom',
          zIndex: 1212121212
        }">
              <span class="icon-bin pointer"></span>
            </div>
            <div class="icon__bg-circle dialog-header__bin"
                 v-if="isPossibleToDelete"
                 @click="isConfirmDelete = true"
                 :content="i18n[locale]['delete_event']"
                 v-tippy="{
          placement: 'bottom',
          zIndex: 1212121212
        }">
              <span class="icon-bin pointer"></span>
            </div>
            <DDropdown :content="i18n[locale]['settings']"
                       v-if="event.calendar_id === calendarId && showSettings && event.event_type !== 'absence'"
                       v-tippy="{placement: 'bottom', zIndex: 12121212}">
              <ul slot="list" class="large-list">
                <li @click="openCopyEventDropdown"><span class="icon-clipboard2"></span>
                  {{ i18n[locale]['copy_event_onward'] }}
                </li>
                <li class="d-item-warning" @click.stop.self="setIsDeleteOnWard">
                  <span class="icon-bin"></span>
                  {{ i18n[locale].delete_events_onward }}
                </li>
                <li @click.stop="setIsCancelLesson(true)" class="d-cancel-lesson-item">
                  <span class="icon-notification22"></span>
                  {{ !isCanceled ? i18n[locale].cancel_event : i18n[locale].uncancel_event }}
                </li>
                <li @click.stop="setIsOutOfSchoolLesson(true)">
                  <span class="icon-home2 icon-home2-away"></span>
                  {{ i18n[locale].out_of_school }}
                </li>
              </ul>
            </DDropdown>
          </template>
          <div class="d-show-event__close icon__bg-circle" @click="closeClick"
               :content="escTooltip"
               v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212
               }">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <DeleteEventOnward v-if="isDeleteOnWard"
                           :isInDCalendar="true"
                           :event="event"
                           @submit="submitDeleteEventOnward"
                           @close="isDeleteOnWard = false">
        </DeleteEventOnward>
        <CopyEvent v-if="isInDCalendar"></CopyEvent>
        <div class="d-show-event__header__text">
          <h1>{{ event.title }}</h1>
          <h4 v-if="isCanEditEvent && event.calendar_id !== calendarId"
              @click="goToCalendarForLesson"
              :content="i18n[locale]['go_to_calendar']"
              v-tippy="{
                placement: 'bottom-start',
                zIndex: 1212121212
              }"
              :class="{'d-show-event__header__text__calendar-link': event.calendar_id !== calendarId}">
            {{ getCalendarName }}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="tw-icon w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"/>
            </svg>
          </h4>
          <h4 v-else>{{ getCalendarName }}</h4>
        </div>
        <template v-if="!isEventLoading">
          <div class="d-show-event__header__text--with-icon">
            <div class="dialog-icon">
              <span class="icon-calendar4" v-if="isCanEditEvent"></span>
            </div>
            <div class="dialog-text dialog-text__time" v-if="!isCanEditEvent">
              {{ dayAndDate }}
            </div>
            <div class="dialog-text dialog-text__date" v-else>
              <p v-if="!isEditDate"
                 @click="isEditDate = true"
                 :content="i18n[locale]['edit_date']"
                 v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212
               }">{{ dayAndDate }}</p>
              <DateSelector
                v-else
                :isOpen="true"
                :date="startDate"
                @changed="setStartDate">
              </DateSelector>
            </div>
          </div>
          <div class="d-show-event__header__text--with-icon">
            <div class="dialog-icon">
              <span class="icon-clock"></span>
            </div>
            <div class="dialog-text dialog-text__time">
              <div class="dialog-text__time__time" v-if="!isCanEditEvent">
                <span class="bold">{{ formattedEventStart }} - {{ formattedEventEnd }}</span>
                ({{ formattedDuration }})
              </div>
              <TimeChanger
                v-if="isCanEditEvent"
                @updateStart="updateStartTime"
                @updateEnd="updateEndTime"
                :start="event.start"
                :end="event.end"
                addClass="doc-times">
              </TimeChanger>
              <transition name="zoomIn">
                <button v-if="isChangesMade" class="bttn-primary bttn box-shadow" @click="save"
                        :content="saveKeyTooltip"
                        v-tippy="{
                    placement : 'bottom',
                    zIndex: 12312312312312
                  }">
                  {{ $t('vue2.common.save') }}
                </button>
              </transition>
            </div>
          </div>
        </template>
        <div class="d-show-event__header__tabs">
          <div class="d-show-event__header__tabs__tab"
               :class="{'d-show-event__header__tabs__tab--active': isTheActiveTab(0)}"
               @click="setTheActiveTab(0)"><span class="icon-pencil"></span> {{ $t('vue2.common.edit') }}
          </div>
          <div class="d-show-event__header__tabs__tab"
               :class="{'d-show-event__header__tabs__tab--active': isTheActiveTab(1)}"
               @click="setTheActiveTab(1)"><span class="icon-clock"></span> {{ i18n[locale]['activity'] }}
          </div>
          <div class="d-show-event__header__tabs__tab"
               v-if="isShowReplaceAndSwap"
               :class="{'d-show-event__header__tabs__tab--active': isTheActiveTab(2)}"
               @click="setTheActiveTab(2)"><span class="icon-shuffle"></span> {{ i18n[locale]['swap_lesson'] }}
          </div>
          <div class="d-show-event__header__tabs__tab"
               v-if="isShowReplaceAndSwap"
               :class="{'d-show-event__header__tabs__tab--active': isTheActiveTab(3)}"
               @click="setTheActiveTab(3)"><span class="icon-shuffle"></span> {{ i18n[locale]['replace_lesson'] }}
          </div>
        </div>
      </div>
      <div class="d-show-event__body" :style="{ maxHeight: `calc(100vh - ${dShowEventBodyMaxHeight}px)` }">
        <Loader v-if="isEventLoading" style="margin-top: 40px" bg-color="#f6f9fc"></Loader>
        <template v-else>
          <div class="d-show-event__form" v-if="isTheActiveTab(0)">
            <template v-if="!isCanEditEvent">
              <div class="input-group input-group--uneditable"
                   v-if="eventUsers.length > 0 && event.event_type !== 'absence'">
                <label><span class="icon-user"></span> {{ $t('vue2.edit_event.teachers') }}</label>
                <div class="event-cals">
                  <div class="event-cals__cal"
                       :class="{'event-cals__cal--sub': user.v_sub}"
                       v-for="user in eventUsers"
                       :key="user.calendar_id">
                    <div v-if="user.v_sub"
                         class="d-select__selected__item__warning icon__bg-circle icon__bg-circle--small"
                         :content="user.v_sub"
                         v-tippy="{
                    arrow: true,
                    placement : 'bottom',
                    zIndex: 1231231231233,
                    boundary: 'window'
                  }">
                      <span class="icon-users3"></span>
                    </div>
                    {{ user.name }}
                  </div>
                </div>
              </div>
              <div class="input-group input-group--uneditable"
                   v-if="eventSubstitutes.length > 0 && event.event_type !== 'absence'">
                <label><span class="icon-users3"></span> {{ $t('vue2.edit_event.substitutes') }}</label>
                <div class="event-cals">
                  <div class="event-cals__cal" v-for="cal in eventSubstitutes" :key="cal.calendar_id">
                    {{ cal.name }}
                  </div>
                </div>
              </div>
              <div class="input-group input-group--uneditable"
                   v-if="eventRooms.length > 0 && event.event_type !== 'absence'">
                <label><span class="icon-location"></span> {{ $t('vue2.edit_event.rooms') }}</label>
                <div class="event-cals">
                  <div class="event-cals__cal" v-for="cal in eventRooms" :key="cal.calendar_id">
                    {{ cal.name }}
                  </div>
                </div>
              </div>
              <div class="input-group input-group--uneditable"
                   v-if="eventKlasses.length > 0 && event.event_type !== 'absence'">
                <label><span class="icon-calendar4"></span> {{ $t('vue2.edit_event.klass') }}</label>
                <div class="event-cals">
                  <div class="event-cals__cal" v-for="cal in eventKlasses" :key="cal.calendar_id">
                    {{ cal.name }}
                  </div>
                </div>
              </div>
              <div class="input-group input-group--uneditable"
                   v-if="eventStudents.length > 0 && event.event_type !== 'absence'">
                <label><span class="icon-calendar4"></span> {{ $t('vue2.students.students') }}</label>
                <div class="event-cals">
                  <div class="event-cals__cal" v-for="cal in eventStudents" :key="cal.calendar_id">
                    {{ cal.name }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <DCalendarShowEventUsersNotOnSchool
                v-if="usersNotOnSchool.length > 0"
                :usersNotOnSchool="usersNotOnSchool"
                :event="event"
                :activeSchoolName="activeSchoolName"
                @updateAndClose="updateAndClose">
              </DCalendarShowEventUsersNotOnSchool>
              <div class="input-group" v-if="event.event_type !== 'absence'">
                <label><span class="icon-user"></span> {{ $t('vue2.edit_event.teachers') }}</label>
                <DSelectCalendars itemType="user"
                                  :showTags="true"
                                  :event="event"
                                  :eventId="event.event_id"
                                  :preSelectedItems="userCalendarIds"
                                  :itemsThatCantBeDeleted="usersWithSubstitute"
                                  :itemsUnselectable="substituteCalendarIds"
                                  :showCreateButton="false"
                                  :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                  :eventSchoolCalendars="eventSchoolCalendars"
                                  :eventSchoolUsers="eventSchoolUsers"
                                  :eventSchoolYears="eventSchoolYears"
                                  :isDeleteAllAnOption="substituteCalendarIds.length === 0"
                                  @updateAndClose="updateAndClose"
                                  @update="setSelectedUsers">
                </DSelectCalendars>
              </div>
              <div class="input-group"
                   v-if="event.event_type !== 'reservation' && event.event_type !== 'absence' && (userCalendarIds.length > 0 || this.ownerCalendarType === 'user')">
                <label><span class="icon-users3"></span> {{ $t('vue2.edit_event.substitutes') }}</label>
                <DSelectCalendars itemType="user"
                                  :showTags="true"
                                  :event="event"
                                  :eventId="event.event_id"
                                  :preSelectedItems="substituteCalendarIds"
                                  :itemsUnselectable="userCalendarIds"
                                  :includeEventCalendar="true"
                                  :showCreateButton="false"
                                  :disableAddMore="possibleTeachersToSub.length < 1"
                                  :disableAddMoreMessage="i18n[locale]['only_one_substitute_per_teacher']"
                                  :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                  :eventSchoolCalendars="eventSchoolCalendars"
                                  :eventSchoolUsers="eventSchoolUsers"
                                  :eventSchoolYears="eventSchoolYears"
                                  @updateAndClose="updateAndClose"
                                  @update="setSelectedSubstitutes">
                </DSelectCalendars>
              </div>
              <div class="input-group" v-if="event.event_type !== 'absence'">
                <label><span class="icon-location"></span> {{ $t('vue2.edit_event.rooms') }}</label>
                <DSelectCalendars itemType="room"
                                  :event="event"
                                  :eventId="event.event_id"
                                  :preSelectedItems="roomCalendarIds"
                                  :showCreateButton="false"
                                  :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                  :eventSchoolCalendars="eventSchoolCalendars"
                                  :eventSchoolUsers="eventSchoolUsers"
                                  :eventSchoolYears="eventSchoolYears"
                                  @updateAndClose="updateAndClose"
                                  @update="setSelectedRooms">
                </DSelectCalendars>
              </div>
              <template v-if="activeEventTypeToSelect === 'kindergarten'">
                <div class="input-group">
                  <label><span class="icon-clipboard2"></span> Stuer</label>
                  <DSelectCalendars itemType="kindergarten"
                                    :event="event"
                                    :eventId="event.event_id"
                                    :preSelectedItems="kindergartenCalendarsIds"
                                    :showCreateButton="false"
                                    :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                    :eventSchoolCalendars="eventSchoolCalendars"
                                    :eventSchoolUsers="eventSchoolUsers"
                                    :eventSchoolYears="eventSchoolYears"
                                    @updateAndClose="updateAndClose"
                                    @update="setSelectedKindergartenCalendar">
                  </DSelectCalendars>
                </div>
              </template>
              <template v-if="activeEventTypeToSelect === 'club'">
                <div class="input-group">
                  <label><span class="icon-clipboard2"></span> {{ $t('vue2.club.club') }}</label>
                  <DSelectCalendars itemType="club"
                                    :event="event"
                                    :eventId="event.event_id"
                                    :preSelectedItems="clubCalendarsIds"
                                    :showCreateButton="false"
                                    :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                    :eventSchoolCalendars="eventSchoolCalendars"
                                    :eventSchoolUsers="eventSchoolUsers"
                                    :eventSchoolYears="eventSchoolYears"
                                    @updateAndClose="updateAndClose"
                                    @update="setSelectedClubCalendar">
                  </DSelectCalendars>
                </div>
              </template>
              <template v-if="activeEventTypeToSelect === 'other'">
                <div class="input-group">
                  <label><span class="icon-clipboard2"></span> {{ $t('vue2.common.other_calendars') }}</label>
                  <DSelectCalendars itemType="other"
                                    :event="event"
                                    :eventId="event.event_id"
                                    :preSelectedItems="otherCalendarsIds"
                                    :showCreateButton="false"
                                    :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                    :eventSchoolCalendars="eventSchoolCalendars"
                                    :eventSchoolUsers="eventSchoolUsers"
                                    :eventSchoolYears="eventSchoolYears"
                                    @updateAndClose="updateAndClose"
                                    @update="setSelectedOtherCalendar">
                  </DSelectCalendars>
                </div>
              </template>
              <template v-if="activeEventTypeToSelect === 'klass'">
                <div class="input-group input-group__label-link"
                     v-if="event.event_type !== 'reservation' && event.event_type !== 'absence' && !isShowKlass">
                  <input type="checkbox" v-model="isShowKlass">
                  <label class="d-link-text" @click="setIsShowKlass(true)">{{ i18n[locale].add_grade }}</label>
                </div>
                <transition name="fadeInLeft" @after-enter="onKlassDSelectTransitionDone">
                  <div class="input-group input-group__grades" v-if="event.event_type !== 'absence' && isShowKlass">
                    <label><span class="icon-calendar4"></span> {{ $t('vue2.edit_event.klass') }}</label>
                    <DSelectCalendars itemType="klass"
                                      :event="event"
                                      :eventId="event.event_id"
                                      :preSelectedItems="klassCalendarIds"
                                      :showCreateButton="false"
                                      :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                      :eventSchoolCalendars="eventSchoolCalendars"
                                      :eventSchoolUsers="eventSchoolUsers"
                                      :eventSchoolYears="eventSchoolYears"
                                      @updateAndClose="updateAndClose"
                                      @update="setSelectedKlasses">
                    </DSelectCalendars>
                  </div>
                </transition>
              </template>
              <div class="input-group"
                   v-if="isStudentsActivated && event.event_type !== 'absence' && event.event_type !== 'reservation'">
                <label><span class="icon-location"></span> {{ $t('vue2.students.students') }}</label>
                <DSelectCalendars itemType="student"
                                  :event="event"
                                  :eventId="event.event_id"
                                  :preSelectedItems="studentCalendarIds"
                                  :showCreateButton="false"
                                  :isEventSchoolIdTheSameAsActiveSchoolId="isEventSchoolIdTheSameAsActiveSchoolId"
                                  :eventSchoolCalendars="eventSchoolCalendars"
                                  :eventSchoolUsers="eventSchoolUsers"
                                  :eventSchoolYears="eventSchoolYears"
                                  @updateAndClose="updateAndClose"
                                  @update="setSelectedStudents">
                </DSelectCalendars>
              </div>
            </template>
            <div class="d-notes"
                 v-if="isShowLearningGoal && (event.learning_goal.length > 0 || event.event_type !== 'absence') && (canEditNotes || (!canEditNotes && event.learning_goal.length > 0))">
              <label :style="{'color': event.color}">
                <span v-if="!isCalendarOfTypeOther">{{ i18n[locale].learning_goal }}</span>
                <span v-if="isCalendarOfTypeOther">{{ i18n[locale].meeting_purpose }}</span>
              </label>
              <div class="dialog-text__content"
                   v-if="!canEditNotes"
                   v-html="event.learning_goal">
              </div>
              <weip
                v-if="canEditNotes"
                :isInDCalendar="true"
                :isInTestOfSaveButton="false"
                :lesson="event"
                noteType="learning_goal"
                @changed="setNoteChanges($event, 'learning_goal')">
              </weip>
            </div>
            <div class="d-notes"
                 v-if="!isShowOnlyNotes && (event.description.length > 0 || event.event_type !== 'absence') && (canEditNotes || (!canEditNotes && event.description.length > 0))">
              <label :style="{'color': event.color}">
                <span v-if="!isCalendarOfTypeOther">{{ i18n[locale].content }}</span>
                <span v-if="isCalendarOfTypeOther">{{ i18n[locale].agenda }}</span>
              </label>
              <weip
                v-if="canEditNotes"
                :isInDCalendar="true"
                :isInTestOfSaveButton="false"
                :lesson="event"
                noteType="description"
                @changed="setNoteChanges($event, 'description')">
              </weip>
              <div class="dialog-text__content"
                   v-html="event.description"
                   v-if="!canEditNotes">
              </div>
            </div>
            <div class="d-notes"
                 v-if="isShowNotesForStudent && (event.notes_for_students.length > 0 || event.event_type !== 'absence') && canEditNotes || (!canEditNotes && event.notes_for_students.length > 0)">
              <label :style="{'color': event.color}">
                <span v-if="!isCalendarOfTypeOther">{{ i18n[locale].pupil_preparation }}</span>
                <span v-if="isCalendarOfTypeOther">{{ i18n[locale].decisions_and_resume }}</span>
              </label>
              <weip
                v-if="canEditNotes"
                :isInDCalendar="true"
                :isInTestOfSaveButton="false"
                :lesson="event"
                noteType="notes_for_students"
                @changed="setNoteChanges($event, 'notes_for_students')">
              </weip>
              <div class="dialog-text__content"
                   v-if="!canEditNotes"
                   v-html="event.notes_for_students">
              </div>
            </div>
            <div class="d-notes"
                 v-if="isShowTeacherNotes && canEditNotes || (!canEditNotes && event.teacher_notes.length > 0)">
              <label :style="{'color': event.color}">
                <span v-if="!isCalendarOfTypeOther">{{ i18n[locale].teacher_notes }}</span>
                <span v-if="isCalendarOfTypeOther">{{ i18n[locale].internal_notes }}</span>
              </label>
              <weip
                v-if="canEditNotes"
                :isInDCalendar="true"
                :isInTestOfSaveButton="false"
                :lesson="event"
                noteType="teacher_notes"
                @changed="setNoteChanges($event, 'teacher_notes')">
              </weip>
              <div class="dialog-text__content"
                   v-if="!canEditNotes"
                   v-html="event.teacher_notes">
              </div>
            </div>
            <div class="input-group" v-if="event.event_type !== 'frame'">
              <label><span class="icon-clock"></span> {{ i18n[locale]['this_lesson_counts_as'] }}</label>
              <p class="lesson-count-as">{{ eventTypeTranslated }}: {{ eventDurationForCalendar }}</p>
            </div>
          </div>
          <div class="d-show-event__form" v-if="isTheActiveTab(1)">
            <EventChanges :event="event" :event-id="event.event_id"></EventChanges>
          </div>
          <div class="d-show-event__form" v-if="isTheActiveTab(2)">
            <EventSwapOrReplace
              :propEvent="event"
              type="swap"
              @update="updateAndClose"
            ></EventSwapOrReplace>
          </div>
          <div class="d-show-event__form" v-if="isTheActiveTab(3)">
            <EventSwapOrReplace
              :propEvent="event"
              type="replace"
              @update="updateAndClose">
            </EventSwapOrReplace>
          </div>
        </template>
      </div>
      <transition name="fadeUp">
        <div class="d-show-event__footer" v-if="isChangesMade">
          <button class="bttn-primary bttn box-shadow"
                  @click="save"
                  :disabled="isUpdating"
                  :content="saveKeyTooltip"
                  v-tippy="{
                    placement : 'top',
                    zIndex: 12312312312312
                  }">{{ $t('vue2.common.save') }}
          </button>
          <button class="bttn box-shadow marg-1-left" @click="close">{{ $t('vue2.common.dont_save') }}</button>
        </div>
      </transition>
      <ModalConfirmation
        :show-close="false"
        :appendToBody="true"
        :isOnlyOwnCalendarText="isOnlyOwnCalendarTextWarning"
        class="d-modal--from-top"
        v-if="isConfirmDelete && !isAway"
        @close="closeIsConfirmDelete"
        @confirm="deleteEvent">
        <div class="d-custom-warning alert" slot="custom_warning" v-if="originalSubstituteCalendarIds.length > 0">
          <span class="icon-users3"></span>
          {{ i18n[locale]['you_are_about_to_delete_substitutes'] }}
        </div>
      </ModalConfirmation>
      <DModalDeleteAwayEvent
        v-if="isConfirmDelete && isAway"
        :event="event"
        :appendToBody="true"
        @deleted="onAwayEventDeleted"
        @close="closeIsConfirmDelete">
      </DModalDeleteAwayEvent>
      <ModalConfirmation
        :show-close="false"
        :appendToBody="true"
        :isShowConfirmDeleteMessage="false"
        class="d-modal--from-top"
        v-if="isConfirmRemoveOwnerAsSubstitute"
        @close="isConfirmRemoveOwnerAsSubstitute = false"
        @confirm="confirmRemoveOwnerAsSubstitute">
        <div class="d-custom-warning alert" slot="custom_warning">
          <span class="icon-users3"></span>
          {{ i18n[locale]['remove_owner_as_substitute'] }}
        </div>
        <template slot="confirmText">{{ i18n[locale]['ok'] }}</template>
      </ModalConfirmation>
      <DCalendarsShowEventSubFor
        v-if="subToSelectWhoToSubFor"
        :substitute="subToSelectWhoToSubFor"
        :teachers="possibleTeachersToSub"
        @select="setTeacherToSub"
        @cancel="cancelSubToSelectWhoToSubFor">
      </DCalendarsShowEventSubFor>
    </div>
    <DModal v-if="isClosingWithoutSaving && !isEventLoading" :show-close="false" :isBgOverlay="true">
      <div class="d-modal d-modal__closing-without-saving text-dark" slot="insertComponent" style="width: 400px">
        <div class="d-modal__header">
          <h2>{{ $t('vue2.common.save_changes') }}</h2>
        </div>
        <div class="d-modal__content">
          <p>{{ i18n[locale]['unsaved_changes_will_be_lost'] }}</p>
        </div>
        <div class="doc-modal__footer">
          <button type="button"
                  class="bttn bttn-primary"
                  @click="save">
            {{ $t('vue2.common.save') }}
          </button>
          <button type="button" @click="close">{{ $t('vue2.common.dont_save') }}</button>
          <button type="button" @click="isClosingWithoutSaving = false">{{ $t('vue2.common.cancel') }}</button>
        </div>
      </div>
    </DModal>
    <DModalCancelLesson v-if="isCancelLesson"
                        :event="event"
                        @updated="onEventUpdated"
                        @close="setIsCancelLesson(false)">
    </DModalCancelLesson>
    <DModalOutOfSchoolLesson
      v-if="isOutOfSchoolLesson"
      :event="event"
      @updated="onEventUpdated"
      @close="setIsOutOfSchoolLesson(false)">
    </DModalOutOfSchoolLesson>
    <div class="d-show-event__overlay" v-if="isChangesMade" @click.stop="closeClick"></div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import Loader from '../common/Loader'
import CopyEvent from '../Events/CopyEvent'
import DeleteEventOnward from '../Events/DeleteEventOnward'
import moment from 'moment'
import DSelectCalendars from '../DSelect/DSelectCalendars'
import weip from '../common/AppEIPWYZIWYG'
import EventChanges from '../Log/EventChanges'
import TimeChanger from '../TimeChanger'
import DDropdown from '../common/DDropdown'
import eventbus from '../../eventbus'
import DModal from '../common/DModal'
import ModalConfirmation from '../Modals/ModalConfirmation'
import DSelectSubs from '../DSelect/DSelectSubs'
import DCalendarsShowEventSubFor from './DCalendarShowEventSubFor'
import docendo from '../../docendo'
import EventSwapOrReplace from '../Events/EventSwapOrReplace'
import DCalendarShowEventUsersNotOnSchool from './DCalendarShowEventUsersNotOnSchool'
import DateSelector from '../datepicker/DateSelector.vue'
import DModalCancelLesson from '../Events/DModalCancelLesson.vue'
import DModalOutOfSchoolLesson from '../Events/DModalOutOfSchoolLesson.vue'
import DModalDeleteAwayEvent from '../Events/DModalDeleteAwayEvent.vue'

const I18N = {
  da: {
    out_of_school: 'Ude af huset',
    hour: 'time',
    hours: 'timer',
    minute: 'minut',
    minutes: 'minutter',
    delete_events_onward: 'Slet lektionen fremadrettet',
    only_one_substitute_per_teacher: 'Det kan kun vælges én vikar per fraværende',
    go_to_calendar: 'Gå til kalender for denne lektion',
    copy_event_onward: 'Kopier lektionen',
    delete_event: 'Slet lektion',
    settings: 'Indstillinger',
    activity: 'Historik',
    learning_goal: 'Læringsmål',
    meeting_purpose: 'Formål med mødet',
    content: 'Indhold',
    agenda: 'Agenda',
    pupil_preparation: 'Elevforberedelse',
    decisions_and_resume: 'Beslutninger og resumé',
    teacher_notes: 'Vikarnoter / Interne noter',
    internal_notes: 'Noter',
    unsaved_changes_will_be_lost: 'Du har lavet ændringer, der er ikke er gemt. Vil du gemme ændringer før du lukker?',
    add_grade: 'Tilføj klasse',
    swap_lesson: 'Byt lektion',
    replace_lesson: 'Erstat lektion',
    only_delete_this: 'Slet kun i denne kalender',
    this_lesson_counts_as: 'Denne lektion tæller som',
    you_are_about_to_delete_substitutes: 'Du er ved at slette en lektion med vikar på. Vikaren vil få fjernet sin lektion. Er det meningen?',
    remove_owner_as_substitute: 'Brugeren sættes i stedet på som underviser på aktiviteten. Skal aktiviteten fjernes helt, så slet den i stedet.',
    ok: 'OK',
    edit_date: 'Rediger dato',
    cancel_event: 'Aflys timen',
    uncancel_event: 'Fortryd aflysning',
    canceled: 'Aflyst'
  },
  en: {
    out_of_school: 'Out of school',
    canceled: 'Canceled',
    cancel_event: 'Cancel lesson',
    uncancel_event: 'Undo cancellation',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    delete_events_onward: 'Delete this and on same timeslot forward',
    only_one_substitute_per_teacher: 'Only one substitute can be chosen per teacher',
    go_to_calendar: 'Go to calendar for the lesson',
    copy_event_onward: 'Copy lesson onward',
    delete_event: 'Delete lesson',
    settings: 'Settings',
    activity: 'History',
    learning_goal: 'Learning goal',
    meeting_purpose: 'Purpose of the meeting',
    content: 'Content',
    agenda: 'Agenda',
    pupil_preparation: 'Homework',
    decisions_and_resume: 'Decisions and summary',
    internal_notes: 'Notes',
    teacher_notes: 'Teachers notes',
    unsaved_changes_will_be_lost: 'Your unsaved changes will be lost. Save changes before close?',
    add_grade: 'Add grade/group',
    swap_lesson: 'Swap Lesson',
    replace_lesson: 'Replace Lesson',
    only_delete_this: 'Only delete in this calendar',
    this_lesson_counts_as: 'This lesson counts as',
    you_are_about_to_delete_substitutes: 'Du er i ferd med å slette en leksjon med vikar. Vikaren vil få fjernet leksjonen sin. Er det meningen?',
    remove_owner_as_substitute: 'The user will instead be put on the activity as a teacher. If the activity should be removed entirely, delete it instead.',
    ok: 'OK',
    edit_date: 'Edit date'
  },
  nb: {
    out_of_school: 'Utenfor skolen',
    canceled: 'Avlyst',
    cancel_event: 'Avlys timen',
    uncancel_event: 'Angre avlysning',
    hour: 'time',
    hours: 'timer',
    minute: 'minutt',
    minutes: 'minutter',
    delete_events_onward: 'Slett denne timen fra nå og fremover',
    only_one_substitute_per_teacher: 'Det kan kun velges én vikar per lærer',
    go_to_calendar: 'Gå til denne timens kalender',
    copy_event_onward: 'Kopier faget',
    delete_event: 'Slett time',
    settings: 'Innstillinger',
    activity: 'Logg',
    learning_goal: 'Læringsmål',
    meeting_purpose: 'Formål med møtet',
    content: 'Innhold',
    agenda: 'Agenda',
    pupil_preparation: 'Lekser',
    decisions_and_resume: 'Beslutninger og sammendrag',
    teacher_notes: 'Vikarnotater',
    internal_notes: 'Notater',
    unsaved_changes_will_be_lost: 'Du har gjort endringer uten å lagre. Vil du lagre før du lukker?',
    add_grade: 'Legg til klasse',
    swap_lesson: 'Bytt time',
    replace_lesson: 'Erstatt time',
    only_delete_this: 'Slett kun i denne kalender',
    this_lesson_counts_as: 'Denne leksjonen teller som',
    you_are_about_to_delete_substitutes: 'You are about to delete a lesson with a substitute. The substitute will have their lesson removed. Is this the intention?',
    remove_owner_as_substitute: 'Brukeren settes i stedet på som underviser på aktiviteten. Skal aktiviteten fjernes helt, så slett den i stedet.',
    ok: 'OK',
    edit_date: 'Rediger dato'
  }
}

export default {
  mixins: [clickaway],
  components: {
    DModalOutOfSchoolLesson,
    DModalDeleteAwayEvent,
    DModalCancelLesson,
    DateSelector,
    DCalendarShowEventUsersNotOnSchool,
    DCalendarsShowEventSubFor,
    DSelectSubs,
    ModalConfirmation,
    DModal,
    DDropdown,
    Loader,
    CopyEvent,
    DSelectCalendars,
    weip,
    EventChanges,
    TimeChanger,
    DeleteEventOnward,
    EventSwapOrReplace
  },
  props: {
    event: {
      type: Object,
      default: () => {
      }
    },
    initCalendarId: {},
    calendar: {
      type: Object,
      default: null
    },
    isInDCalendar: {
      type: Boolean,
      default: false
    },
    showSettings: {
      type: Boolean,
      default: true
    },
    canEditEvent: {
      type: Boolean,
      default: true
    },
    canEditNotes: {
      type: Boolean,
      default: true
    },
    isInitEventLoading: {
      type: Boolean,
      default: false
    },
    isDCalendarInROR: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEventLoading: false,
      eventSchoolCalendars: [],
      isLoadingEventSchoolCalendars: false,
      eventSchoolUsers: [],
      isLoadingEventSchoolUsers: false,
      eventSchoolYears: [],
      isLoadingEventSchoolYears: false,
      calendars: [],
      ownerCalendarId: null,
      userCalendarIds: [],
      roomCalendarIds: [],
      klassCalendarIds: [],
      studentCalendarIds: [],
      otherCalendarsIds: [],
      kindergartenCalendarsIds: [],
      clubCalendarsIds: [],
      substituteCalendarIds: [],
      originalSubstituteCalendarIds: [],
      substitutionsToSubmit: [/* {subCalendarId: 7, subForUserId: 12} */],
      isSubsInputFieldActive: false,
      theActiveTab: 0,
      isEditTime: false,
      isChangesMade: false,
      updatedStartTime: null,
      updatedEndTime: null,
      isConfirmDelete: false,
      isDeleteOnWard: false,
      theSubstitutesUserId: null,
      theSubstituteForUserId: null,
      noteChanges: {},
      subToSelectWhoToSubFor: null,
      isClosingWithoutSaving: false,
      isUpdating: false,
      keyboardShortcutAdded: false,
      isShowKlass: false,
      isOnlyOwnCalendarTextWarning: false,
      headerHeight: 192,
      theRemoveCalendarModal: false,
      isShowKlassAnimate: false,
      theChangesMade: {},
      startDate: moment(),
      isEditDate: false,
      isCancelLesson: false,
      isOutOfSchoolLesson: false,
      isConfirmRemoveOwnerAsSubstitute: false
    }
  },
  computed: {
    isCanceled () {
      return this.event.canceled
    },
    isAway () {
      return this.event.away
    },
    isCanEditEvent () {
      const eventTypeIsAbsence = this.event.event_type === 'absence'
      if (!eventTypeIsAbsence) {
        return this.canEditEvent
      }
      // Fravær kan ikke redigeres hvis skolen har et lønsystem tilknyttet
      if (this.isSalaySystemAbsenceActivated) {
        return false
      }
      const schoolIdsWithoutDeleteFnc = [29045]
      return schoolIdsWithoutDeleteFnc.indexOf(this.schoolId) < 0 ? true : this.userHasPermission('can_manage_users')
    },
    user () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    locale () {
      return this.$store.getters.locale
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    activeSchoolName () {
      return this.activeSchool ? this.activeSchool.name : ''
    },
    dShowEventBodyMaxHeight () {
      return this.isChangesMade ? (this.headerHeight * 1) + 41 : this.headerHeight
    },
    calendarId () {
      return this.initCalendarId * 1
    },
    schoolFeatures () {
      return this.$store.getters.schoolFeatures
    },
    isSalaySystemAbsenceActivated () {
      return this.schoolFeatures.indexOf('kmd_absence') > -1
    },
    isPossibleToDelete () {
      const eventTypeIsAbsence = this.event.event_type === 'absence'
      // Hvis skolen har kmd_absence-featuren, må fravær ikke slettes i kalenderen
      if (eventTypeIsAbsence && this.isSalaySystemAbsenceActivated) {
        return false
      }
      const schoolIdsWithoutDeleteFnc = [29045]
      const isActivatedForUsers = schoolIdsWithoutDeleteFnc.indexOf(this.schoolId) < 0 ? true : this.userHasPermission('can_manage_users')
      const isOwnerOtherCalendar = this.ownerCalendarType === 'other' ? this.event.calendar_id === this.calendarId : true

      return (!eventTypeIsAbsence || (eventTypeIsAbsence && isActivatedForUsers)) && isOwnerOtherCalendar
    },
    eventTypeTranslated () {
      return this.$t(`vue2.eventTypes.${this.event.event_type}`)
    },
    eventDurationForCalendar () {
      const calendar = this.event.calendars.find(cal => cal.calendar_id === this.calendarId)
      if (!calendar) {
        return ''
      }
      const minutes = calendar.minutes
      // Check if minutes are greater than 60 to convert into hours and minutes format
      if (minutes >= 60) {
        const hours = Math.floor(minutes / 60)
        const remainingMinutes = parseFloat((minutes % 60).toFixed(2))
        const hourLabel = hours === 1 ? this.i18n[this.locale]['hour'] : this.i18n[this.locale]['hours']
        const minuteLabel = remainingMinutes === 1 ? this.i18n[this.locale]['minute'] : this.i18n[this.locale]['minutes']
        return `${hours} ${hourLabel} ${remainingMinutes} ${minuteLabel}`
      }

      const rounded = parseFloat(minutes.toFixed(2))
      const minuteLabel = rounded === 1 ? this.i18n[this.locale]['minute'] : this.i18n[this.locale]['minutes']
      return `${rounded} ${minuteLabel}`
    },
    eventMainCalendarType () {
      const mainCalendar = this.allCalendarsInHash[this.event.calendar_id]
      if (mainCalendar) {
        return mainCalendar.type
      } else {
        return null
      }
    },
    isShowLearningGoal () {
      return !this.isShowOnlyNotes && !this.isKindergarten
    },
    isShowNotesForStudent () {
      return !this.isShowOnlyNotes && !this.isKindergarten
    },
    isShowTeacherNotes () {
      return !this.isKindergarten
    },
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    isShowReplaceAndSwap () {
      return this.isCanEditEvent && this.event.event_type !== 'absence' && !this.isKindergarten
    },
    activeEventTypeToSelect () {
      let calType = 'klass'
      // Ensure `event_type` and fallback value
      const eventType = this.event && this.event.event_type ? this.event.event_type : 'v_unknown'
      // Specific school IDs for `klass` event type
      const schoolIdsWhereAvailableInShowEvent = [60598]
      // For Tilsyn
      const calendarType = this.calendar && this.calendar.type ? this.calendar.type : ''
      if (calendarType === 'klass' && eventType === 'additional_tasks') {
        return 'klass'
      }
      const otherArr = ['other_tasks', 'other_stuff', 'available', 'additional_tasks', 'preparation']
      const kindergartenArr = ['with_kids', 'without_kids']

      // Conditional logic for Rådighedstime
      if (
        this.event &&
        this.event.school_id &&
        schoolIdsWhereAvailableInShowEvent.includes(this.event.school_id) &&
        eventType === 'available'
      ) {
        return 'klass'
      }
      if (otherArr.includes(eventType)) {
        return 'other'
      }

      if (eventType === 'club') {
        return 'club'
      }

      if (kindergartenArr.includes(eventType)) {
        return 'kindergarten'
      }

      return calType
    },
    isStudentsActivated () {
      const schoolFeatures = window.SCHOOL && window.SCHOOL.features ? window.SCHOOL.features : []
      return schoolFeatures.indexOf('calendar_student') > -1
    },
    isLoadingEventSchoolCalendarsOrUsers () {
      return this.isLoadingEventSchoolCalendars || this.isLoadingEventSchoolUsers || this.isLoadingEventSchoolYears
    },
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    },
    saveKeyTooltip () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>'
    },
    escTooltip () {
      return '<p class="tooltip-shortcut">' + this.$t('vue2.common.close') + '<span>Esc</span></p>'
    },
    ownerCalendarType () {
      if (this.allCalendarsInHash && this.allCalendarsInHash[this.event.calendar_id]) {
        return this.allCalendarsInHash[this.event.calendar_id].type
      }
      // If user has no rights to see other calendar
      return null
    },
    isShowOnlyNotes () {
      const eventTypes = ['reservation']
      return this.event ? eventTypes.indexOf(this.event.event_type) > -1 : false
    },
    isCalendarOfTypeOther () {
      const eventTypes = ['other_tasks', 'reservation', 'available', 'additional_tasks', 'preparation', 'pool']
      return this.event ? eventTypes.indexOf(this.event.event_type) > -1 : false
    },
    possibleTeachersToSub () {
      let possibleTeachersToSub = []
      const teachersWithSub = this.calendars.filter(cal => cal.substitute).map(calendar => calendar.substitute)
      // Copy to avoid mutating userCalendarIds (it is also used as itemsUnselectable
      // in the substitute select, where the owner must stay selectable)
      let users = this.userCalendarIds.slice()
      if (this.ownerCalendarType === 'user' && this.ownerCalendarId) {
        users.push(this.ownerCalendarId)
      }
      users.forEach(userCalId => {
        const user = this.allUsersInCalendarHash[userCalId]
        if (!user) {
          console.log('teachersWithSub::user_not_found', userCalId, this.allUsersInCalendarHash)
        } else {
          if (teachersWithSub.indexOf(user.id) < 0) {
            possibleTeachersToSub.push(user)
          }
        }
      })
      return possibleTeachersToSub
    },
    i18n () {
      if (this.isKindergarten) {
        I18N['da']['go_to_calendar'] = 'Gå til kalender for denne aktivitet'
        I18N['da']['delete_events_onward'] = 'Slet aktiviteten fremadrettet'
        I18N['da']['copy_event_onward'] = 'Kopier aktiviteten'
        I18N['da']['delete_event'] = 'Slet aktivitet'
      }
      return I18N
    },
    copyEventEvent () {
      return eventbus.copyEventEvent
    },
    allCalendarsInHash () {
      let cals = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.calendars : this.eventSchoolCalendars
      return cals.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    },
    allUsersInHash () {
      let users = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers
      return users.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    },
    allUsersInCalendarHash () {
      let users = this.isEventSchoolIdTheSameAsActiveSchoolId ? this.$store.state.allUsers : this.eventSchoolUsers
      return users.reduce((obj, item) => {
        obj[item.user_calendar_id] = item
        return obj
      }, {})
    },
    isEventSchoolIdTheSameAsActiveSchoolId () {
      if (!this.event) {
        return false
      }
      const eventSchoolId = this.event.school_id * 1
      const activeSchoolId = this.schoolId * 1
      if (eventSchoolId === activeSchoolId) {
        return true
      }
      // Split schools: use active school resources (klasser etc.) instead of the event's other school_id
      const schoolIdsFromHornslet = [64478, 62460]
      return schoolIdsFromHornslet.indexOf(eventSchoolId) > -1 &&
        schoolIdsFromHornslet.indexOf(activeSchoolId) > -1
    },
    getCalendarName () {
      return this.allCalendarsInHash[this.event.calendar_id] ? this.allCalendarsInHash[this.event.calendar_id].name : ''
    },
    calendarIds () {
      return this.klassCalendarIds.concat(this.roomCalendarIds, this.userCalendarIds, this.substituteCalendarIds, this.studentCalendarIds, this.otherCalendarsIds, this.kindergartenCalendarsIds, this.clubCalendarsIds, [this.ownerCalendarId])
    },
    dayAndDate () {
      // NN hack
      if (this.locale === 'nn' || this.locale === 'nb') {
        return moment(this.event.start).format('dddd DD. MMMM YYYY')
      }
      try {
        return moment(this.event.start)._d.toLocaleDateString(this.locale, {
          weekday: 'long',
          month: 'long',
          day: '2-digit',
          year: 'numeric'
        })
      } catch (e) {
        return moment(this.event.start).format('LL')
      }
    },
    usersWithSubstitute () {
      let usersWithSub = []
      this.calendars.forEach(calendar => {
        const theCalendar = this.allCalendarsInHash[calendar.calendar_id]
        if (calendar.substitute && theCalendar && theCalendar.type === 'user') {
          const userWithSub = this.allUsersInHash[calendar.substitute]
          if (userWithSub) {
            usersWithSub.push(userWithSub.user_calendar_id)
          }
        }
      })
      return usersWithSub
    },
    formattedEventStart () {
      return moment(this.event.start).format('LT')
    },
    formattedEventEnd () {
      return moment(this.event.end).format('LT')
    },
    eventDuration () {
      const end = this.event.end
      const start = this.event.start
      return moment.duration(moment(end).diff(moment(start))).asMinutes()
    },
    eventMinutes () {
      const hours = Math.floor(this.eventDuration / 60)
      const minutes = (this.eventDuration - hours * 60)
      return minutes
    },
    eventHours () {
      return Math.floor(this.eventDuration / 60)
    },
    formattedDuration () {
      const hours = this.eventHours < 1 ? '' : this.eventHours + ' ' + (this.eventHours === 1 ? this.i18n[this.locale]['hour'] : this.i18n[this.locale]['hours'])
      const minutes = this.eventMinutes >= 1 ? this.eventMinutes + ' min' : ''
      return hours + ' ' + minutes
    },
    eventUsers () {
      return this.calendars
        .filter(calEvent => calEvent.calendar_type === 'user' && !calEvent.substitute && !calEvent.is_substitute)
        .map(user => ({
          ...user,
          v_sub: this.findSubstitute(user)
        }))
    },
    eventSubstitutes () {
      return this.calendars.filter(calEvent => calEvent.substitute || calEvent.is_substitute)
    },
    eventRooms () {
      return this.calendars.filter(calEvent => calEvent.calendar_type === 'room')
    },
    eventKlasses () {
      return this.calendars.filter(calEvent => calEvent.calendar_type === 'klass')
    },
    eventStudents () {
      return this.calendars.filter(calEvent => calEvent.calendar_type === 'student')
    },
    isEveryThingReady () {
      return !this.isInitEventLoading && this.locale && !this.isLoadingEventSchoolCalendarsOrUsers
    },
    calsNotOnSchool () {
      return this.calendars.filter(cal => !this.allCalendarsInHash[cal.calendar_id])
    },
    usersNotOnSchool () {
      return this.calsNotOnSchool.filter(cal => cal.calendar_type === 'user')
    }
  },
  watch: {
    event (val) {
      this.setTheActiveTab(0)
      this.checkIfEventSchoolIdIsActiveSchoolId()
    },
    isEveryThingReady (val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.d_show_event_header) {
            this.headerHeight = this.$refs.d_show_event_header.getBoundingClientRect().height
          }
        })
      }
    }
  },
  methods: {
    setIsOutOfSchoolLesson (bool) {
      this.isOutOfSchoolLesson = bool
    },
    onEventUpdated () {
      this.setIsCancelLesson(false)
      this.setIsOutOfSchoolLesson(false)
      this.$emit('updated')
      this.close()
    },
    setIsCancelLesson (bool) {
      this.isCancelLesson = bool
    },
    findSubstitute (calEvent) {
      const user = this.allUsersInCalendarHash[calEvent.calendar_id]
      if (!user) {
        return null
      }
      const userId = user.id
      const calEventSubsForUser = this.calendars.filter(calendar => calendar.substitute === userId)
      const names = calEventSubsForUser.filter(calEvent => this.allUsersInCalendarHash[calEvent.calendar_id]).map(user => user.name)
      return names.join(', ')
    },
    setStartDate (date) {
      this.startDate = date
      this.setChangesMade('date')
    },
    userHasPermission (permission) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(permission) > -1 || this.user.admin
      } else {
        return true
      }
    },
    setIsShowKlass (bool) {
      this.isShowKlassAnimate = true
      this.isShowKlass = bool
    },
    onKlassDSelectTransitionDone () {
      if (!this.isShowKlassAnimate) {
        return
      }
      const el = document.querySelector('.input-group__grades .d-select__input-look')
      el.click()
    },
    setIsConfirmDeleteMerge () {
      this.isOnlyOwnCalendarTextWarning = true
      this.isConfirmDelete = true
    },
    getCalendarNames (calIds) {
      const names = calIds.map(calId => {
        const idx = this.calendars.findIndex(cal => cal.calendar_id === calId)
        if (idx > -1) {
          return this.calendars[idx].name
        }
      })
      // const names = calIds.filter(calId => this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId].name)
      return names.join(', ').toString()
    },
    closeClick (evt) {
      function isTargetCalendarEvent (evt) {
        var target = evt.target
        while (target != null) {
          if (target.classList.contains('fc-event') || target.classList.contains('day-cal__event')) {
            return true
          }
          if (target.classList.contains('js-no-close')) {
            return true
          }
          target = target.parentElement
        }
        return false
      }

      if (isTargetCalendarEvent(evt)) {
        return
      }
      if (this.copyEventEvent || this.isDeleteOnWard) {
        return
      }
      if (this.isChangesMade) {
        this.isClosingWithoutSaving = true
        return
      }
      this.close()
    },
    setTeacherToSub (teacher) {
      const obj = {
        calendar_id: this.subToSelectWhoToSubFor.calendarId,
        substitute: teacher.id,
        substitute_for_cal_id: teacher.user_calendar_id
      }
      this.calendars.push(obj)
      this.substitutionsToSubmit.push(obj)
      this.subToSelectWhoToSubFor = null
    },
    cancelSubToSelectWhoToSubFor () {
      this.subToSelectWhoToSubFor.calendarId
      this.subToSelectWhoToSubFor = null
    },
    setNoteChanges (note, noteType) {
      this.$set(this.noteChanges, noteType, note)
      this.setChangesMade('notes')
    },
    setChangesMade (changeType) {
      this.$set(this.theChangesMade, changeType, true)
      this.isChangesMade = true
    },
    setIsDeleteOnWard () {
      this.$refs.d_show_event.click()
      this.isDeleteOnWard = true
    },
    openCopyEventDropdown () {
      eventbus.copyEventEvent = this.event
    },
    goToCalendarForLesson () {
      if (this.isInDCalendar && !this.isDCalendarInROR) {
        this.$store.commit('setActiveCalendarId', this.event.calendar_id)
        this.close()
      } else {
        window.location.href = window.location.href = '/calendars/' + this.event.calendar_id
        this.close()
      }
    },
    updateStartTime (time) {
      const newStartTime = moment(this.event.start).hours(moment(time).hours()).minutes(moment(time).minutes())
      this.updatedStartTime = newStartTime
      this.setChangesMade('time')
    },
    updateEndTime (time) {
      const newEndTime = moment(this.event.end).hours(moment(time).hours()).minutes(moment(time).minutes())
      this.updatedEndTime = newEndTime
      this.setChangesMade('time')
    },
    save () {
      if (this.isUpdating) return
      this.isClosingWithoutSaving = false
      let updates = [{
        event_id: this.event.event_id
      }]
      const isOwnerSubRemoved = this.originalSubstituteCalendarIds.includes(this.ownerCalendarId) &&
        !this.substituteCalendarIds.includes(this.ownerCalendarId)
      const allCalendarIds = this.calendarIds.concat(
        this.calsNotOnSchool
          .map(cal => cal.calendar_id)
          .filter(calendarId => !this.calendarIds.includes(calendarId))
      ).filter((calendarId, idx, arr) => arr.indexOf(calendarId) === idx)
      if (this.theChangesMade['calendars']) {
        updates[0]['calendar_ids'] = allCalendarIds
      }
      if (this.theChangesMade['time']) {
        updates[0]['start_time'] = this.updatedStartTime
        updates[0]['end_time'] = this.updatedEndTime
      }
      if (this.theChangesMade['date']) {
        // Opdaterer this.updatedStartTime med år, måned og dag fra this.startDate
        const newStartDate = moment(this.updatedStartTime)
          .year(moment(this.startDate).year())
          .month(moment(this.startDate).month())
          .date(moment(this.startDate).date())

        // Beregner forskellen i dage mellem updatedStartTime og updatedEndTime
        const diffInDays = moment(this.updatedEndTime).diff(moment(this.updatedStartTime), 'days')

        // Opdaterer newEndDate baseret på forskellen i dage uden at ændre this.updatedEndTime
        let newEndDate = moment(newStartDate).add(diffInDays, 'days')

        // Beholder tiden fra this.updatedEndTime, men bruger datoen fra newEndDate
        newEndDate = newEndDate
          .hour(moment(this.updatedEndTime).hour())
          .minute(moment(this.updatedEndTime).minute())
          .second(moment(this.updatedEndTime).second())

        // Opdaterer start_time og end_time i updates, uden at ændre this.updatedEndTime
        updates[0]['start_time'] = newStartDate
        updates[0]['end_time'] = newEndDate
      }
      // Check notes
      const noteKeys = Object.keys(this.noteChanges)
      if (noteKeys.length > 0) {
        let noteChanges = {
          event_id: this.event.event_id
        }
        noteKeys.forEach(key => {
          noteChanges[key] = this.noteChanges[key]
        })
        updates.push(noteChanges)
      }
      // Check substitutes. The owner's own calendar is excluded here and
      // handled separately below, so the activity survives the removal
      const subCalIdsToRemove = this.originalSubstituteCalendarIds
        .filter(x => !this.substituteCalendarIds.includes(x))
        .filter(x => x !== this.ownerCalendarId)
      if (subCalIdsToRemove.length > 0) {
        updates['remove_substitute_calendar_id'] = subCalIdsToRemove[0]
      }
      subCalIdsToRemove.forEach(subCalId => {
        const removeSub = {
          event_id: this.event.event_id,
          remove_substitute_calendar_id: subCalId
        }
        updates.push(removeSub)
      })
      // Removing the owner's own substitute-marking: remove_substitute_calendar_id
      // deletes the owner's calendar_event, but the following calendar_ids entry
      // (processed afterwards in the same backend transaction) re-adds the owner
      // as a regular teacher, so the activity stays in the calendar
      if (isOwnerSubRemoved) {
        updates.push({
          event_id: this.event.event_id,
          remove_substitute_calendar_id: this.ownerCalendarId
        })
        updates.push({
          event_id: this.event.event_id,
          calendar_ids: allCalendarIds
        })
      }
      // Substitutes without anyone to cover for can not be expressed in the
      // api.events.update payload and are added via api.events.add_substitute instead
      const subsWithoutSubFor = this.substitutionsToSubmit.filter(subObj => !subObj.substitute_for_cal_id)
      this.substitutionsToSubmit.filter(subObj => subObj.substitute_for_cal_id).forEach(subObj => {
        const subUpdate = {
          event_id: this.event.event_id,
          calendar_id: subObj.substitute_for_cal_id,
          add_substitute_calendar_id: subObj.calendar_id
        }
        updates.push(subUpdate)
      })
      const addSubsWithoutSubForThenPersist = () => {
        if (subsWithoutSubFor.length < 1) {
          persist()
          return
        }
        let doneCount = 0
        const onDone = () => {
          doneCount++
          if (doneCount === subsWithoutSubFor.length) {
            persist()
          }
        }
        subsWithoutSubFor.forEach(subObj => {
          const user = this.allUsersInCalendarHash[subObj.calendar_id]
          if (!user) {
            onDone()
            return
          }
          docendo.eventAddSubstitute(this.event.event_id, user.id, null, onDone, onDone)
        })
      }
      const persist = () => {
        const updatedLesson = {
          school_id: this.event.school_id,
          updates: updates
        }
        if (this.isInDCalendar) {
          if (this.isCanEditEvent) {
            this.$store.dispatch('updateCalendarEvent', updatedLesson)
          } else {
            // Different permission for notes only
            const updateEvent = {
              schoolId: this.event.school_id,
              eventId: this.event.event_id,
              updates: this.noteChanges
            }
            this.$store.dispatch('updateCalendarEventNotes', updateEvent)
          }
          this.close()
        } else {
          this.isEventLoading = true
          docendo.updateEvents(updatedLesson.school_id, updatedLesson.updates, success => {
            this.$emit('updated')
            this.close()
          })
        }
      }
      const periodChanged = this.theChangesMade['date'] || this.theChangesMade['time']
      const newStart = updates[0]['start_time'] || this.event.start
      const newEnd = updates[0]['end_time'] || this.event.end
      const samePeriod = moment(newStart).format('YYYY-MM-DD HH:mm') === moment(this.event.start).format('YYYY-MM-DD HH:mm') &&
        moment(newEnd).format('YYYY-MM-DD HH:mm') === moment(this.event.end).format('YYYY-MM-DD HH:mm')
      if (this.isAway && periodChanged && !samePeriod) {
        this.isUpdating = true
        this.applyAwayPeriodLessonUpdates(newStart, newEnd, overlapUpdates => {
          this.isUpdating = false
          updates = updates.concat(overlapUpdates)
          addSubsWithoutSubForThenPersist()
        })
        return
      }
      addSubsWithoutSubForThenPersist()
    },
    eventHasOtherKlasses (ev, tripKlassIds) {
      const calendars = (ev && (ev.calendars || ev.calendar_events)) || []
      const klassIds = calendars
        .filter(c => c && c.calendar_type === 'klass')
        .map(c => c.calendar_id)
      if (klassIds.length === 0) return false
      return klassIds.some(id => tripKlassIds.indexOf(id) === -1)
    },
    fetchKlassEventsForPeriod (calendarIds, start, end, callback) {
      if (!calendarIds || calendarIds.length === 0) {
        callback([])
        return
      }
      docendo.calendarEvents2(
        calendarIds,
        moment(start).format('YYYY-MM-DD HH:mm'),
        moment(end).format('YYYY-MM-DD HH:mm'),
        null,
        success => {
          callback(success && success.length > 0 ? JSON.parse(success) : [])
        },
        () => {
          callback([])
        }
      )
    },
    applyAwayPeriodLessonUpdates (newStart, newEnd, callback) {
      const selfId = this.event.event_id
      const oldKlassIds = (this.event.calendars || [])
        .filter(c => c && c.calendar_type === 'klass')
        .map(c => c.calendar_id)
      let newKlassIds = (this.klassCalendarIds || []).slice()
      const ownerCal = (this.event.calendars || []).find(c => {
        return c && c.calendar_id === this.event.calendar_id
      })
      if (ownerCal && ownerCal.calendar_type === 'klass' && newKlassIds.indexOf(ownerCal.calendar_id) === -1) {
        newKlassIds.push(ownerCal.calendar_id)
      }
      if (newKlassIds.length === 0) {
        newKlassIds = oldKlassIds
      }

      let pending = 2
      let oldEvents = []
      let newEvents = []
      const done = () => {
        pending -= 1
        if (pending > 0) return
        const cancelCandidates = newEvents.filter(ev => {
          const notAlreadyCanceled = ev && ev.canceled !== true
          const notAlreadyAway = ev && ev.away !== true
          const notSelf = !selfId || (ev.event_id !== selfId && ev.id !== selfId)
          const hasOtherKlasses = this.eventHasOtherKlasses(ev, newKlassIds)
          return notAlreadyCanceled && notAlreadyAway && notSelf && !hasOtherKlasses
        })
        const cancelIds = {}
        cancelCandidates.forEach(ev => {
          cancelIds[ev.event_id || ev.id] = true
        })
        const restoreCandidates = oldEvents.filter(ev => {
          const isCanceled = ev && ev.canceled === true
          const notAway = ev && ev.away !== true
          const notSelf = !selfId || (ev.event_id !== selfId && ev.id !== selfId)
          const eventId = ev.event_id || ev.id
          return isCanceled && notAway && notSelf && !cancelIds[eventId]
        })
        const overlapUpdates = restoreCandidates.map(ev => {
          return {event_id: ev.event_id || ev.id, canceled: false}
        }).concat(cancelCandidates.map(ev => {
          return {event_id: ev.event_id || ev.id, canceled: true}
        }))
        callback(overlapUpdates)
      }
      this.fetchKlassEventsForPeriod(oldKlassIds, this.event.start, this.event.end, events => {
        oldEvents = events
        done()
      })
      this.fetchKlassEventsForPeriod(newKlassIds, newStart, newEnd, events => {
        newEvents = events
        done()
      })
    },
    closeIsConfirmDelete () {
      this.isOnlyOwnCalendarTextWarning = false
      this.isConfirmDelete = false
    },
    onAwayEventDeleted () {
      this.isConfirmDelete = false
      if (this.isInDCalendar) {
        this.$store.commit('setActiveCalendarEventId', null)
        this.$store.commit('deleteActiveCalendarEvent', this.event)
        this.$store.dispatch('readCalendarSubjects')
      }
      this.$emit('updated')
      this.close()
    },
    deleteEvent () {
      this.isConfirmDelete = true
      if (this.isOnlyOwnCalendarTextWarning) {
        docendo.deleteEventCalendar(this.event.event_id, this.calendarId, success => {
          this.$emit('updated')
          this.isOnlyOwnCalendarTextWarning = false
          this.close()
        })
      } else {
        if (this.isInDCalendar) {
          this.$store.dispatch('deleteEvent', this.event)
          this.close()
        } else {
          this.isEventLoading = true
          docendo.deleteEvent(this.event.school_id, this.event.event_id, success => {
            this.$emit('updated')
            this.close()
          })
        }
      }
    },
    updateAndClose () {
      this.$emit('updated')
      this.close()
    },
    setIsEditTime () {
      this.setChangesMade('time')
    },
    isTheActiveTab (tab) {
      return this.theActiveTab === tab
    },
    setTheActiveTab (tab) {
      this.theActiveTab = tab
    },
    submitDeleteEventOnward () {
      this.$emit('submitDeleteEventOnward')
      this.close()
    },
    close () {
      this.isClosingWithoutSaving = false
      this.resetChangesMade()
      this.$nextTick(_ => {
        this.$emit('close')
      })
    },
    setSelectedUsers (users) {
      this.userCalendarIds = users.map(user => user.id)
      this.setChangesMade('calendars')
    },
    setSelectedSubstitutes (users) {
      // Substitute changes are persisted via add_substitute/remove_substitute entries.
      // They must not trigger the calendar_ids sync in save(), since that resets
      // the substitute markings on the event
      this.setChangesMade('substitutes')
      const before = this.substituteCalendarIds
      const after = users.map(user => user.id)
      const subCalIdsToAdd = after.filter(x => !before.includes(x))
      const subCalIdsToRemove = before.filter(x => !after.includes(x))
      // Removing the owner's saved substitute-marking on their own activity
      // needs a confirmation: the user stays on the activity as a teacher instead
      if (subCalIdsToRemove.indexOf(this.ownerCalendarId) > -1 && this.originalSubstituteCalendarIds.indexOf(this.ownerCalendarId) > -1) {
        this.isConfirmRemoveOwnerAsSubstitute = true
        // Retrigger preSelectedItems so the select restores the removed tag until confirmed
        this.substituteCalendarIds = this.substituteCalendarIds.slice()
        return
      }
      this.substituteCalendarIds = users.map(user => user.id)
      if (subCalIdsToRemove.length > 0) {
        subCalIdsToRemove.forEach(calId => {
          const idx = this.calendars.findIndex(cal => cal.calendar_id === calId && (cal.substitute || cal.is_substitute))
          if (idx > -1) {
            this.calendars.splice(idx, 1)
          }
          const idx2 = this.substitutionsToSubmit.findIndex(cal => cal.calendar_id === calId)
          if (idx2 > -1) {
            this.substitutionsToSubmit.splice(idx2, 1)
          }
        })
      }
      // We must add a substitute
      if (subCalIdsToAdd.length > 0) {
        // Users that are already on the event (the owner or personnel) are set
        // as substitutes on their own activity without covering for anyone
        const selfSubCalIds = subCalIdsToAdd.filter(calId => calId === this.ownerCalendarId || this.userCalendarIds.indexOf(calId) > -1)
        selfSubCalIds.forEach(calId => {
          const obj = {
            calendar_id: calId,
            substitute: true,
            substitute_for_cal_id: null
          }
          this.calendars.push(obj)
          this.substitutionsToSubmit.push(obj)
        })
        const subCalIdsNeedingSubFor = subCalIdsToAdd.filter(calId => selfSubCalIds.indexOf(calId) < 0)
        if (subCalIdsNeedingSubFor.length < 1) {
          return
        }
        // Find out to set substitute for
        // There is only one teachers and he/she isn't substituted already
        if (this.possibleTeachersToSub.length === 1) {
          subCalIdsNeedingSubFor.forEach(calId => {
            const user = this.possibleTeachersToSub[0]
            if (user) {
              const obj = {
                calendar_id: calId,
                substitute: user.id,
                substitute_for_cal_id: user.user_calendar_id
              }
              this.calendars.push(obj)
              this.substitutionsToSubmit.push(obj)
            }
          })
        }
        // There are multiple teachers to substitute for
        if (this.possibleTeachersToSub.length > 1) {
          this.subToSelectWhoToSubFor = {
            calendarId: subCalIdsNeedingSubFor[0],
            name: this.allUsersInCalendarHash[subCalIdsNeedingSubFor[0]].name
          }
          return
        }
      }
    },
    confirmRemoveOwnerAsSubstitute () {
      this.isConfirmRemoveOwnerAsSubstitute = false
      this.setChangesMade('substitutes')
      // On save the diff against originalSubstituteCalendarIds makes save()
      // remove the substitute-marking and re-add the user via calendar_ids,
      // so the user stays on the activity as a teacher
      this.substituteCalendarIds = this.substituteCalendarIds.filter(calId => calId !== this.ownerCalendarId)
      const idx = this.substitutionsToSubmit.findIndex(subObj => subObj.calendar_id === this.ownerCalendarId)
      if (idx > -1) {
        this.substitutionsToSubmit.splice(idx, 1)
      }
    },
    setSelectedRooms (rooms) {
      this.roomCalendarIds = rooms.map(cal => cal.id)
      this.setChangesMade('calendars')
    },
    setSelectedKlasses (klasses) {
      this.klassCalendarIds = klasses.map(cal => cal.id)
      this.setChangesMade('calendars')
    },
    setSelectedStudents (cals) {
      this.studentCalendarIds = cals.map(cal => cal.id)
      this.setChangesMade('calendars')
    },
    setSelectedOtherCalendar (cals) {
      this.otherCalendarsIds = cals.map(cal => cal.id)
      this.setChangesMade('calendars')
    },
    setSelectedKindergartenCalendar (cals) {
      this.kindergartenCalendarsIds = cals.map(cal => cal.id)
      this.setChangesMade('calendars')
    },
    setSelectedClubCalendar (cals) {
      this.clubCalendarsIds = cals.map(cal => cal.id)
      this.setChangesMade('calendars')
    },
    resetChangesMade () {
      this.theChangesMade = {}
      this.isChangesMade = false
    },
    reset () {
      this.ownerCalendarId = null
      this.userCalendarIds = []
      this.roomCalendarIds = []
      this.klassCalendarIds = []
      this.otherCalendarsIds = []
      this.kindergartenCalendarsIds = []
      this.clubCalendarsIds = []
      this.substituteCalendarIds = []
      this.originalSubstituteCalendarIds = []
      this.studentCalendarIds = []
      this.isShowKlass = false
      this.isOnlyOwnCalendarTextWarning = false
      this.resetChangesMade()
    },
    setInitialEventData () {
      this.reset()
      this.updatedStartTime = this.event.start
      this.updatedEndTime = this.event.end
      this.startDate = this.event.start
      this.event.calendars.forEach(calendar => {
        if (calendar.calendar_id === this.event.calendar_id) {
          this.ownerCalendarId = calendar.calendar_id
          // The owner can be a substitute on their own activity
          if (calendar.calendar_type === 'user' && (calendar.substitute || calendar.is_substitute)) {
            this.substituteCalendarIds.push(calendar.calendar_id)
            this.originalSubstituteCalendarIds.push(calendar.calendar_id)
          }
        } else {
          const theCalendar = calendar // this.allCalendarsInHash[calendar.calendar_id]
          if (theCalendar) {
            switch (theCalendar.calendar_type) {
              case 'klass':
                if (this.ownerCalendarId !== calendar.calendar_id) {
                  this.isShowKlass = true
                }
                this.klassCalendarIds.push(calendar.calendar_id)
                break
              case 'room':
                this.roomCalendarIds.push(calendar.calendar_id)
                break
              case 'other':
                this.otherCalendarsIds.push(calendar.calendar_id)
                break
              case 'club':
                this.clubCalendarsIds.push(calendar.calendar_id)
                break
              case 'kindergarten':
                this.kindergartenCalendarsIds.push(calendar.calendar_id)
                break
              case 'student':
                this.studentCalendarIds.push(calendar.calendar_id)
                break
              case 'user':
                // is_substitute covers substitutes without anyone to cover for
                if (calendar.substitute || calendar.is_substitute) {
                  this.substituteCalendarIds.push(calendar.calendar_id)
                  this.originalSubstituteCalendarIds.push(calendar.calendar_id)
                } else {
                  this.userCalendarIds.push(calendar.calendar_id)
                }
                break
            }
          }
        }
      })
      // https://www.samanthaming.com/tidbits/70-3-ways-to-clone-objects/
      this.calendars = JSON.parse(JSON.stringify(this.event.calendars))
    },
    setConfirmationMessage (e) {
      var confirmMessage = 'Continue without saving?'
      if (this.isChangesMade) {
        (e || window.event).returnValue = confirmMessage // Gecko + IE
        return confirmMessage // Webkit, Safari, Chrome
      }
    },
    handleKeyboardShortcut1 (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        if (e.target.closest && e.target.closest('.d-select')) {
          return
        }
        e.preventDefault()
        this.save()
      }
    },
    handleKeyboardShortcut2 (e) {
      if (e.key === 'Escape') {
        e.preventDefault()
        if (this.isChangesMade) {
          this.isClosingWithoutSaving = true
          return
        }
        this.close()
      }
    },
    checkIfEventSchoolIdIsActiveSchoolId () {
      this.eventSchoolCalendars = []
      this.eventSchoolUsers = []
      let isUsersLoaded = false
      let isCalendarsLoaded = false
      let isSchoolYearsLoaded = false
      if (!this.event) {
        return
      }
      if (this.isEventSchoolIdTheSameAsActiveSchoolId) {
        this.setInitialEventData()
      } else {
        this.isLoadingEventSchoolCalendars = true
        docendo.calendarsForSchool(this.event.school_id, data => {
          this.eventSchoolCalendars = data
          this.isLoadingEventSchoolCalendars = false
          isCalendarsLoaded = true
          if (isUsersLoaded && isSchoolYearsLoaded) {
            this.setInitialEventData()
          }
        })
        this.isLoadingEventSchoolUsers = true
        docendo.schoolUsers2(this.event.school_id, data => {
          this.eventSchoolUsers = data
          this.isLoadingEventSchoolUsers = false
          isUsersLoaded = true
          if (isCalendarsLoaded && isSchoolYearsLoaded) {
            this.setInitialEventData()
          }
        })
        this.isLoadingEventSchoolYears = true
        docendo.schoolYearsRead(this.event.school_id, '', 'id', data => {
          this.eventSchoolYears = data.filter(year => year.active)
          this.isLoadingEventSchoolYears = false
          isSchoolYearsLoaded = true
          if (isCalendarsLoaded && isUsersLoaded) {
            this.setInitialEventData()
          }
        })
      }
    }
  },
  mounted () {
    this.checkIfEventSchoolIdIsActiveSchoolId()
    window.addEventListener('beforeunload', this.setConfirmationMessage)
    // Add event listeners for keyboard shortcuts if they haven't already been added
    if (!this.keyboardShortcutAdded) {
      window.addEventListener('keydown', this.handleKeyboardShortcut1)
      window.addEventListener('keydown', this.handleKeyboardShortcut2)
      this.keyboardShortcutAdded = true
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.setConfirmationMessage)
    // Remove event listeners when component is destroyed
    window.removeEventListener('keydown', this.handleKeyboardShortcut1)
    window.removeEventListener('keydown', this.handleKeyboardShortcut2)
    this.keyboardShortcutAdded = false
  }
}
</script>


<style>
@import "../../assets/css/variables.css";

.d-show-event {
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  max-width: 600px;
  z-index: 1000;
  background: #f6f9fc;
}

.device--is-mobile .d-show-event {
  font-size: 10px;
  max-width: 100vw;
}

.d-show-event__content {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #f6f9fc;
  box-shadow: 0 0 10px rgb(0 0 0 / 8%);
  z-index: 1001;
  border-left: 1px solid #e9e9e9;
  overflow: auto;
}


.d-show-event__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 999;
  background: transparent;
}

.d-show-event__header {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 165px;
  padding: 1rem 2rem 0 2rem;
  color: #ffffff;
}

.d-show-event__header__top {
  display: flex;
  justify-content: flex-end;
}

.d-show-event__header__top button {
  margin-left: 0.5rem;
}

.d-show-event__header h1 {
  color: #ffffff;
  margin: 0 0 0.5rem 0;
}

.d-show-event__header h4 {
  opacity: 0.8;
}

.d-show-event__close.icon__bg-circle {
  font-size: 1.2rem;
}

.d-show-event__header__text {
  padding: 0 2rem;
}

.zoomIn-enter-active {
  animation: zoomIn .25s;
}

.zoomIn-leave-active {
  animation: zoomIn .25s reverse;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }

  50% {
    opacity: 1;
  }
}

.d-show-event__header__text--with-icon {
  display: flex;
  align-items: center;
}

.dialog-icon {
  width: 2rem;
}

.d-show-event__form {
  position: relative;
}

.d-show-event__form .input-group {
  margin-bottom: 0.5rem;
  padding-bottom: 1rem;
}

.d-show-event__form .input-group label {
  margin-bottom: 6px;
}

.input-group.input-group--inactive .d-select__input-look,
.input-group.input-group--inactive .d-select__input-look input[type="search"] {
  box-shadow: none;
  background: #f6f9fc;
  border: 1px solid #eeeeee;
}

.input-fake--inactive {
  background: #f6f9fc;
  border: 1px solid #eeeeee;
  width: 100%;
  color: #757575;
  transition: width 0.25s;
  border-radius: 4px;
  cursor: text;
  height: 34px;
  display: flex;
  align-items: center;
  padding: 9px;
}

.d-show-event__header__tabs {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  margin-right: -1rem;
}

.d-show-event__header__tabs__tab {
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
}

.d-show-event__header__tabs__tab span {
  font-size: 11px;
  margin-right: 0.25rem;
}

.d-show-event__header__tabs__tab--active {
  background-color: #f6f9fc;
  color: #3e4450;
  font-weight: bold;
}


.d-notes {
  border-bottom: 1px solid #edf0f5;
  margin-bottom: 1rem;
}

.dialog-text__time {
  display: flex;
  align-items: center;
  height: 32px;
}

.dialog-text__time > .bttn-primary.bttn {
  padding: 2px 30px;
}

.doc-times {
  margin-right: 1rem;
}

.d-show-event__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  border-top: 1px solid #e6e8eb;
  box-shadow: 0px -2px 10px rgb(0 0 0 / 10%);
}

.fadeUp-enter-active, .fadeUp-leave-active {
  transition: transform 0.5s;
  transform: translateY(0);
}

.fadeUp-enter, .fadeUp-leave-to {
  transform: translateY(100%);
}

.d-modal__closing-without-saving .d-modal__content {
  display: flex;
  justify-content: center;
  padding: 0.5rem 2rem 0 2rem;
}

.d-modal__closing-without-saving .d-modal__content > button:first-child {
  margin-right: 1rem;
}

.dialog-text__time__time {
  margin-right: 0.5rem;
}

.d-show-event__body {
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 1rem 2rem;
}

.d-calendar__event__calendar-names {
  font-weight: bold;
}

.input-group--uneditable {
  border-bottom: 1px solid #edf0f5;
}

.dialog-text__content {
  padding: 0.5rem 0 1rem 0;
}

.doc-modal__footer {
  flex-direction: column;
}

.doc-modal__footer button {
  margin-bottom: 0.5rem;
}

.d-show-event__init-loader {
  margin-top: 30vh;
}

.d-show-event__header__text__calendar-link {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: background-color .3s;
  margin: 0 -4px;
  padding: 0 4px;
}

.d-show-event__header__text__calendar-link:hover {
  background: rgba(0, 0, 0, .16);
  border-radius: 4px;
  opacity: 1;
}

.d-show-event__header__text__calendar-link > svg {
  margin-top: -4px;
  margin-left: 4px;
}

.d-show-event__form .input-group.input-group__label-link {
  padding-bottom: 0;
  margin-bottom: 1rem;
}

.input-group label.d-link-text {
  color: #a2a3a6;
  cursor: pointer;
  display: inline-block;
  text-transform: initial;
  font-size: 11px;
  font-weight: normal;
  padding: 0.5rem 0.75rem;
  transition: background-color 0.25s, color 0.25s;
  border-radius: 4px;
  border: 1px dashed #a2a3a6;
  margin-bottom: 0;
}

.input-group label.d-link-text:hover {
  background-color: #fff;
  color: var(--primary);
}

.input-group__label-link input[type="checkbox"] {
  display: none;
}

.lesson-count-as {
  color: #a2a3a6;
}

.d-custom-warning {
  margin: 0 1rem;
}

.alert {
  font-weight: normal;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 11px;
  line-height: 1.5;
  color: #a26206;
  max-width: 600px;
}

.d-show-event__close__loader {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.dialog-text__date p {
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid hsla(0, 0%, 100%, .5);
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  transition: background-color .15s, color .15s;
  cursor: pointer;
}

.dialog-text__date p:hover {
  background-color: rgba(0, 0, 0, .16);
}

.doc-times input:hover:not(:focus) {
  background-color: rgba(0, 0, 0, .16);
}

.event-cals {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.event-cals__cal {
  display: flex;
  align-items: center;
  font-weight: bold;
  border: 1px solid #c8d6e2;
  padding: 0 0.5rem;
  border-radius: 4px;
}

.event-cals__cal.event-cals__cal--sub {
  padding: 0 0.5rem 0 0.25rem;
}

.d-show-event__header__do-warning__container {
  position: absolute;
  left: 4rem;
  top: 1rem;
  display: inline-flex;
  gap: 0.5rem;
}

.d-show-event__header__do-warning.do-warning {
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 3px 8px;
}


.do-warning.do-warning--canceled {
  background-color: #fddddd;
  color: #c20006;
  border-color: #fddddd;
}

.large-list > li {
  display: flex;
  align-items: center;
  gap: 0.5rem
}

</style>



// WEBPACK FOOTER //
// DCalendarShowEvent.vue?699a13e2